<template lang="pug">
main
    PmHeader
    transition(name="move")
      pm-notification(v-show = "showNotificationCertificado")
        p(slot = "body")
          strong {{ mensajeCertificado }}
          
    transition(name="move")
      pm-warning(v-show = "showNotification")
        p(slot = "body")
          strong {{ mensaje }}
    .container
      nav.panel.is-info
        p.panel-heading
          |   Menú
        a.panel-block
          p
            router-link.nav-item(to = "factura") Facturas
        a.panel-block
          p
            router-link.nav-item(to = "retencion") Retenciones
        a.panel-block
          p
            router-link.nav-item(to = "liquidacioncompra") Liquidaciones de Compras
        a.panel-block
          p
            router-link.nav-item(to = "notacredito") Notas de Crédito
        a.panel-block
          p
            router-link.nav-item(to = "notadebito") Notas de Débito
        a.panel-block
          p
            router-link.nav-item(to = "guia") Guías de Remisión
        a.panel-block(v-show = "showNotification")
          router-link.button.button.is-warning.is-fullwidth(to = "pendiente")
            |
            strong Pendientes
        .panel-block
          router-link.button.button.is-info.is-rounded.is-fullwidth(to = "suscripcion") Suscripción
        .panel-block
          router-link.button.button.is-link.is-outlined.is-fullwidth(to = "contacto") Contacto
</template>
<script>
import PmWarning from '@/components/shared/Warning.vue'
import PmNotification from '@/components/shared/Notification.vue'
import PmHeader from '../components/layout/Header.vue'

import trackService from '@/services/track'
import certificateService from '@/services/certificateService'

export default {
  components: {
    PmWarning, PmNotification, PmHeader
  },

  data: () => ({
    tracks: [],
    mensaje: '',
    showNotification: false,
    showNotificationCertificado: false,
    mensajeCertificado: '',
    numeroPendientes: 0,
    usuario: {}
  }),

  mounted() {
    if (localStorage.getItem('token')) {
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  },

  methods: {
    getNumeroPendientes () {
      this.showNotification = false
      trackService.contarPendiente()
        .then(res => {
          this.tracks = res
          this.numeroPendientes = Number(this.tracks[0])
          console.log(`Número de pendientes: ${this.numeroPendientes}`)
          // True si es mayor a cero
          this.showNotification = this.numeroPendientes > 0
          if (this.showNotification) {
            this.mensaje = `Existen ${this.numeroPendientes} documentos pendientes de enviar al SRI`
          }
        })
    },
    getCertificadoExpira () {
      this.showNotificationCertificado = false
      certificateService.certificadoCaduca()
        .then(res => {          
          let dias = res
          this.showNotificationCertificado = dias < 31
          // console.log(`Certificado ${dias} ${this.showNotificationCertificado}`)
          if (this.showNotificationCertificado) {
            this.mensajeCertificado = `El certificado tiene ${dias} días de validez.
            Es necesario renovar o adquirir el certificado dígital`
          }
        })
    }
  },

  beforeMount () {
    this.getNumeroPendientes()
    this.getCertificadoExpira()
  }
}
</script>
